import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from '@client-monorepo/common/ui-components';
import { BillServicesComponent } from '../../components/bill-services/bill-services.component';
import { CharityServicesComponent } from '../../components/charity-services/charity-services.component';
import { GroupedAppServicesComponent, SelectedServicesPreviewComponent } from '@client-monorepo/common/app-services';
import { Banner, BannerCategory, BannersApiService, SharedCommonBannersComponent } from '@client-monorepo/libs/shared/common/banners';
import { AssetsSliderComponent } from '@client-monorepo/common/user-assets';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppService,
  AppServiceCategoryNamesEnum,
  appServicesCategoriesConst,
  FrequentServiceInterface,
  FrequentServicesIdEnum,
} from '@client-monorepo/common/service-data';
import { AbTestService, InitiatorService, ScrolledToEndDirective, StickyObserverDirective } from '@client-monorepo/common/utilities';
import { BackHandlerService } from '@client-monorepo/back-handler';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { UpcomingTransactionsSummaryComponent } from '@client-monorepo/payment/transactions';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
import { GeoEntityService } from '@client-monorepo/common/location-management';

@Component({
  selector: 'hub-applet-main',
  standalone: true,
  imports: [
    CommonModule,
    BillServicesComponent,
    SelectedServicesPreviewComponent,
    GroupedAppServicesComponent,
    CharityServicesComponent,
    SharedCommonBannersComponent,
    AssetsSliderComponent,
    SearchComponent,
    ScrolledToEndDirective,
    UpcomingTransactionsSummaryComponent,
    StickyObserverDirective,
    NgxSkeletonLoadingComponent,
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent implements OnInit {
  appServiceService = inject(AppService);
  bannersApiService = inject(BannersApiService);
  backHandler = inject(BackHandlerService);

  router = inject(Router);
  readonly BannerCategory = BannerCategory;
  services = signal<Array<FrequentServiceInterface>>([]);
  billService = computed(() => {
    return this.services()?.find((service) => service.id === FrequentServicesIdEnum.BILL);
  });
  servicesLoading = signal<boolean>(true);
  bannersData = computed<Banner[]>(() => {
    return this.allBannersData().filter((banner) => {
      if (!banner.geoRestricted) {
        return true;
      }
      return this.geoEntitiesBanner()[banner.uuid];
    });
  });
  allBannersData = signal<Banner[]>([]);
  geoEntitiesBanner = signal<{ [key: string]: boolean }>({});
  appServicesCategoriesConst = appServicesCategoriesConst;
  AppServiceCategoryNamesEnum = AppServiceCategoryNamesEnum;
  loadDeferBlock = signal([false, false, false]);
  lastDeferBlockRendered = -1;
  bottomSheetService = inject(NgxBottomSheetService);
  activatedRoute = inject(ActivatedRoute);
  shouldSkipDeferLoading = signal<boolean>(false);
  initiatorService = inject(InitiatorService);
  geoEntityService = inject(GeoEntityService);

  ngOnInit(): void {
    if (AbTestService.isShowHome()) {
      this.initiatorService.initiate();
    }
    this.shouldSkipDeferLoading.set(this.backHandler.shouldSkipDeferLoading(this.router.url));
    this.getAppServices();
    this.getBanners();
    // this.getGeoEntity();
  }
  checkDeffer(index: number): boolean {
    return this.loadDeferBlock()[index] || this.shouldSkipDeferLoading();
  }

  private getAppServices(): void {
    this.appServiceService.getMappedServices().subscribe({
      next: (result) => {
        this.services.set(result);
        this.servicesLoading.set(false);
      },
    });
  }

  private getBanners(): void {
    this.bannersApiService.getBanners().subscribe({
      next: (result) => {
        this.allBannersData.set(result.banners);
      },
    });
  }

  // private getGeoEntity(): void {
  //   this.geoEntityService.getHashMapOfClassName('banner').subscribe({
  //     next: (res) => {
  //       this.geoEntitiesBanner.set(res);
  //     },
  //   });
  // }

  gotoSearch(): void {
    this.router.navigate(['/hub/search']);
  }
}
